import microApp from '@micro-zoe/micro-app'
import { create } from 'zustand'
import { getApps, getFunctions, getNavs, getUser } from '@/features/auth'

type AppStore = {
  layout: { showNav: boolean; showHeader: boolean }
  /**
   * 当前激活的导航路径
   */
  activePaths: string
  /**
   * 初始化数据
   * @returns
   */
  initData: () => Promise<void>
  /**
   * 设置布局
   * @param options
   * @returns
   */
  setLayoutOptions: (options: any) => void
  /**
   * 设置导航路径
   * @param paths
   * @returns
   */
  setActivePaths: (code: string) => void
}

export const useAppStore = create<AppStore>((set, get) => ({
  user: {},
  layout: { showNav: false, showHeader: false },
  activePaths: '',
  initData: async () => {
    try {
      // 校验用户身份
      const identity = await getUser()

      const [apps, navs, permissions] = await Promise.all([getApps(), getNavs(), getFunctions()])

      return new Promise((resolve) => {
        // 初始化时，将基础配置写入全局
        microApp.setGlobalData(
          {
            user: identity,
            org: { apps, navs, permissions },
            layout: { showNav: false, showHeader: false }
          },
          () => {
            resolve()
          }
        )
      })
    } catch (e) {
      return new Promise((resolve) => {
        // 初始化时，将基础配置写入全局
        microApp.setGlobalData(
          {
            user: {},
            org: { apps: [], navs: [], permissions: [] },
            layout: { showNav: false, showHeader: false }
          },
          () => {
            resolve()
          }
        )
      })
    }
  },
  setLayoutOptions: async (options: any) => {
    set((state) => ({ layout: { ...state.layout, ...(options || {}) } }))
  },
  setActivePaths: (code: string) => {
    const { org = {} } = microApp.getGlobalData() || {}
    const { navs = [] } = org as any
    const nav = navs.find((n: any) => n.code === code)

    if (nav) {
      set(() => ({ activePaths: nav.parentIds }))
    } else {
      set(() => ({ activePaths: '' }))
    }
  }
}))
